import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToastMessage {
  id?: number;
  key?: string;
  severity?: string;
  summary?: string;
  detail?: string;
  sticky?: boolean;
  life?: number;
}

@Injectable()
export class ToastCustomService {
  private toastSubject = new Subject<ToastMessage>();
  onMessage$ = this.toastSubject.asObservable();

  constructor() { }

  add(message: ToastMessage) {
    console.log('ToastCustomService: Adding message', message);
    message.id = Date.now();
    this.toastSubject.next(message);
  }

  addAll(messages: ToastMessage[]) {
    messages.forEach(m => this.add(m));
  }

  clear(key?: string) {
    // Implement clear if needed, though usually handled by individual toast auto-close
  }
}
